module.exports = __webpack_public_path__ + "img/nopicture.2e827863.png";